var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://www.skandiafastigheter.se/globalassets/om-oss/personuppgifter/behandling-av-personuppgifter-vid-bostadsuthyrning.docx.pdf","target":"_blank"}},[_c('strong',[_vm._v("Information om Skandia Fastigheter")])])])
}]

export { render, staticRenderFns }